export default {
  SET_EXCLUDED(state, excluded) {
    state.excluded = excluded;
  },
};
